// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Migration_PreflightFranquiasResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract de GET /migration/franquias/preflight
 * (controllers/migration/franquias.php::preflight).
 *
 * Pre-voo da etapa E1: uma linha por unidade ATIVA do Zoho, com os blockers e
 * se ela ja veio. NADA e escrito — nem `migration_runs`, nem `migration_id_map`,
 * nem `migration_errors`. E a leitura que a tela da fase 5 faz antes de
 * qualquer botao de migrar.
 *
 * `dados` e a LISTA direta (sem chave embrulhando), porque a resposta nao tem
 * nenhuma outra informacao a carregar: o que existe alem das unidades — total,
 * quantas bloqueadas — e derivavel da propria lista, e duplicar isso no wire
 * criaria uma segunda opiniao sobre a mesma verdade.
 *
 * A public key do Zoho NAO aparece aqui, nem em nenhum campo, por construcao:
 * ela vive apenas em `ZohoMigrationApi` (backend-only, decisao 21).
 */
import type { Migration_PreflightFranquiaRow } from './Migration_PreflightFranquiaRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Migration_PreflightFranquiasResponseDados = Migration_PreflightFranquiaRow[];

export type Migration_PreflightFranquiasResponse = ApiResponse<Migration_PreflightFranquiasResponseDados>;

registerResponseContract('Migration_PreflightFranquiasResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      zoho_id:    { type: 'string',  required: false },
      nome:       { type: 'string',  required: false },
      cnpj:       { type: 'string',  required: false },
      cidade:     { type: 'string',  required: false },
      uf:         { type: 'string',  required: false },
      ja_migrada: { type: 'boolean', required: false },
      blockers: {
        type: 'array',
        required: false,
        items: {
          code:     { type: 'string',  required: false },
          message:  { type: 'string',  required: false },
          severity: { type: 'string',  required: false },
          entity:   { type: 'string',  required: false },
          zoho_id:  { type: 'string',  required: false },
          label:    { type: 'string',  required: false },
        },
      },
    },
  },
})
